import type { FC } from 'react'
import { TreeItem } from '@mui/x-tree-view'
import { WorklistName } from './WorklistTreeName'
import { WorklistsListResponse } from '@fireflyhealth/api'

interface WorklistSubCategoryProps {
  subCategoryItems: WorklistsListResponse
  category: string
  subCategory: string
  selectWorklist: (id: number) => void
  worklistId: number | undefined
}

export const WorklistSubCategory: FC<WorklistSubCategoryProps> = (
  props: WorklistSubCategoryProps,
) => {
  return (
    <TreeItem
      key={props.category + ' ' + props.subCategory}
      sx={{ mt: '8px', '& > .MuiTreeItem-content .MuiTreeItem-label': { fontWeight: 500 } }}
      itemId={props.category + ' ' + props.subCategory}
      label={props.subCategory}
    >
      {Object.values(props.subCategoryItems)
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        .map(worklist => (
          <WorklistName
            key={worklist.id}
            worklist={worklist}
            worklistId={props.worklistId}
            selectWorklist={props.selectWorklist}
          ></WorklistName>
        ))}
    </TreeItem>
  )
}
